// added by plop

export class GetAddressesStreet {
  static type = '[GetAddressesStreet] directoryAddresses';

  constructor(public textSearch: string) {
  }
}


export class GetAddressesCity {
  static type = '[GetAddressesCity] directoryAddresses';

  constructor(public textSearch: string) {
  }
}


export class GetAddressesCountry {
  static type = '[GetAddressesCountry] directoryAddresses';

  constructor(public textSearch: string) {
  }
}

